import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { IPortionPositionItem } from 'types';
import Text from 'components/Text/Text';
import { ImgUploaderByPreSignedUrl } from 'components/ImgUploader/ImgUploaderByPreSignedUrl';
import { Badge } from 'components/Badge';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IPortionPositionItem;
	positionNumber: number;
	dragHandleProps?: DraggableProvidedDragHandleProps;
}

export const Item: React.FC<IProps> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const portionRowClasses = classNames(style.portion, style.row);
	const portionNameClasses = classNames(style.portionName);
	const posNameRowClasses = classNames(style.posName, style.row);
	const articleNumberRowClasses = classNames(style.articleNumber, style.row);
	const externalIdRowClasses = classNames(style.externalId, style.row);
	const priceRowClasses = classNames(style.price, style.row);
	const isDisabledRowClasses = classNames(style.isDisabled, style.row);

	return (
		<div className={containerClasses}>
			<div className={portionRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<Text className={portionNameClasses} translationKey={data.name} withTooltip={true} />
			</div>
			<Text className={posNameRowClasses} translationKey={data.posName} withTooltip={true} />
			<Text className={articleNumberRowClasses} translationKey={data.articleNumber} withTooltip={true} />
			<Text className={externalIdRowClasses} translationKey={data.externalId} withTooltip={true} />
			<Text
				className={priceRowClasses}
				translationKey={`${data.currencySymbol || ''} ${data.price || 0}`}
				withTooltip={true}
			/>
			<div className={isDisabledRowClasses}>
				<Badge color={data.isDisabled ? 'red' : 'purple'}>
					<Text
						translationNameSpace="listing"
						translationKey={data.isDisabled ? 'isDisabledLabel' : 'availableLabel'}
						asFragment={true}
						data-test="isHidden"
					/>
				</Badge>
			</div>
		</div>
	);
};
